export default "__VITE_ASSET__2d88cb82__"